import React, { useState, useEffect } from 'react';
import Title from 'Components/Title';
import useTranslation from 'Hooks/useTranslation';
import { Radio, RadioGroup, FormControlLabel, FormControl, Alert, AlertTitle } from '@mui/material';
import useModal from './Hooks/useModal';
import useCourses from './Hooks/useCourses';
import useHandleCourseStatus from './Hooks/useHandleCourseStatus';
import useHandleRadioChange from './Hooks/useHandleRadioChange';
import { ContainerPublish, ContainerStatus, radioButton, CustomMsg, WarningMessage } from './style';
import useFetch from './Hooks/useFetch';

export default function EditCoursePost({ courseId, isDraft }) {
  const { t2 } = useTranslation('EditCoursePost');
  const { setOpenModal, ConfirmationModal } = useModal();
  const [isCurrentlyDraft, setIsCurrentlyDraft] = useState(isDraft);
  const [changeMade, setChangeMade] = useState(false);
  const { courseUpdate, validCourse } = useFetch(courseId);
  const { sendToCourses } = useCourses();
  const handleCourseStatus = useHandleCourseStatus(courseUpdate, sendToCourses);
  const handleRadioChange = useHandleRadioChange(setIsCurrentlyDraft, setChangeMade);

  const disableButton = !changeMade || !validCourse;

  return (
    <ContainerPublish>
      <Title
        title={t2('Publish')}
        textButton={t2('Save')}
        disabledButton={disableButton}
        eventButton={() => setOpenModal(true)}
      />
      <div style={{ width: '93%', margin: 'auto' }}>
        <ContainerStatus>
          <div style={{ paddingBottom: '2em' }}>{t2('Title')}</div>
          <FormControl>
            <RadioGroup value={isCurrentlyDraft} onChange={() => handleRadioChange(!isCurrentlyDraft, isDraft, true)}>
              <FormControlLabel sx={radioButton} value control={<Radio />} label={t2('Draft')} />
              <CustomMsg>{t2('DraftMsg')}</CustomMsg>
              <FormControlLabel sx={radioButton} value={false} control={<Radio />} label={t2('Published')} />
              <CustomMsg>{t2('PublishedMsg')}</CustomMsg>
            </RadioGroup>
          </FormControl>
        </ContainerStatus>
        {validCourse !== undefined && !validCourse && (
          <WarningMessage>
            <Alert severity="warning" variant="filled">
              {`${t2('Warning')} - ${t2('CourseBasicInfoError')}`}
            </Alert>
          </WarningMessage>
        )}
      </div>
      <ConfirmationModal onAccept={() => handleCourseStatus(courseId, isCurrentlyDraft)} isDraft={isCurrentlyDraft} />
    </ContainerPublish>
  );
}
